import { StoreActionType as Type } from '../../types';

export const setCheckOperatorInfo: any =
    (dispatch: any) =>
    (operatorData: any): any => {
        return new Promise((resolve: any): any => {
            dispatch({
                type: Type.SET_CHECK_OPERATOR_INFO,
                info: operatorData,
            });
            resolve();
        });
    };
